import { render, staticRenderFns } from "./memorandum.vue?vue&type=template&id=1d929993&scoped=true&"
import script from "./memorandum.vue?vue&type=script&lang=js&"
export * from "./memorandum.vue?vue&type=script&lang=js&"
import style0 from "./memorandum.vue?vue&type=style&index=0&id=1d929993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d929993",
  null
  
)

export default component.exports